(function () {
    const MAX = 10;
    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    const ALLOWED_EXTENSIONS = [ 'png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff', 'tif', 'pdf', 'xls', 'xlsx', 'doc', 'docx' ];
    const ACCEPT_TYPES = ALLOWED_EXTENSIONS.map(function (e) { return '.' + e; }).join(',');
    function extensionOf(name) {
      const parts = String(name).split('.');
      if (parts.length < 2 || parts[0] === '') return '';
      return parts.pop().toLowerCase().trim();
    }
    function isAllowed(file) {
      return ALLOWED_EXTENSIONS.indexOf(extensionOf(file.name)) !== -1;
    }
    const DELETE_ICON_HTML = '<i class="fas fa-trash-alt" style="color:#000;font-size:16px;"></i>';
    function init() {
      const input = document.getElementById('image-file-input');
      const list  = document.getElementById('file-preview-list');
      if (!input || !list) return;
      if (input.dataset.previewReady) return;
      input.dataset.previewReady = '1';
      input.setAttribute('accept', ACCEPT_TYPES);
      let files = [];
      input.addEventListener('change', function () {
        let over = false;
        const oversized = [];
        const invalid = [];
        Array.from(input.files).forEach(function (f) {
          if (!isAllowed(f)) { invalid.push(f.name); return; }
          if (f.size > MAX_FILE_SIZE) { oversized.push(f.name); return; }
          if (files.length >= MAX) { over = true; return; }
          files.push(f);
        });
        apply();
        const messages = [];
        if (invalid.length) messages.push('対応していない形式のファイルです：' + invalid.join('、'));
        if (oversized.length) messages.push('1ファイル10MBまでです：' + oversized.join('、'));
        if (over) messages.push('添付できるのは' + MAX + 'ファイルまでです。');
        if (messages.length) alert(messages.join('\n'));
      });
      function apply() {
        const dt = new DataTransfer();
        files.forEach(function (f) { dt.items.add(f); });
        input.files = dt.files;
        render();
      }
      function render() {
        list.innerHTML = '';
        files.forEach(function (file, index) {
          const li = document.createElement('li');
          li.className = 'd-flex align-items-center mb-1';
          const name = document.createElement('span');
          name.textContent = file.name;
          li.appendChild(name);
          const btn = document.createElement('a');
          btn.href = 'javascript:void(0)';
          btn.className = 'ml-2';
          btn.innerHTML = DELETE_ICON_HTML;
          btn.addEventListener('click', function () {
            files.splice(index, 1);
            apply();
          });
          li.appendChild(btn);
          list.appendChild(li);
        });
      }
    }
    document.addEventListener('DOMContentLoaded', init);
  })();
